import { render, staticRenderFns } from "./PromoRandom.vue?vue&type=template&id=6a89a198&scoped=true&lang=html&"
import script from "./PromoRandom.vue?vue&type=script&lang=js&"
export * from "./PromoRandom.vue?vue&type=script&lang=js&"
import style0 from "./PromoRandom.vue?vue&type=style&index=0&id=6a89a198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89a198",
  null
  
)

export default component.exports